import React from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import SpecificheLogo from './SpecificheLogo';
import { LOGO_HALF_MAX_WIDTH } from './logoSectionLayout';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: LOGO_HALF_MAX_WIDTH,
    // Heading, upload box and specifications take one row each of the three
    // the parent lays out, so they line up with the other half's.
    display: 'grid',
    gridRow: 'span 3',
    gridTemplateRows: 'subgrid',
  },
  intestazione: {
    // Matches the gutters the upload box carries from its own Container, so
    // the heading and the box below it come out the same width.
    padding: `0 ${theme.spacing(3)}px`,
    // Row one is as tall as the taller of the two descriptions. Sitting at the
    // top of it keeps both headings on the same line as each other; the half
    // with the shorter description carries the slack under it instead.
    alignSelf: 'start',
  },
  riquadro: {
    // LogoHeaderTemplate spaces itself for the "Dettagli app" tab, which
    // renders it bare. Here the rows do the spacing, so drop that margin
    // rather than edit a component the other tab depends on.
    '&& > *': {
      marginTop: 0,
      marginBottom: 0,
      // Its 296px floor reserves height for a tab that stacks these boxes
      // loosely; here the grid row already sizes them, and the floor only
      // leaves dead space between the upload button and the file rules.
      minHeight: 0,
    },
  },
  titolo: {
    // subtitle1 is the same size and weight as the description under it, so
    // the two read as one block. The section headings on this tab are set
    // apart by weight alone; this is that device one level down.
    fontWeight: theme.typography.fontWeightBold,
  },
  descrizione: {
    margin: '4px 0',
  },
}));

/**
 * One half of the "Logo del brand" section: says which logo this is and where
 * it ends up, wraps whichever upload box was handed to it, and states the file
 * rules underneath.
 *
 * The upload boxes themselves stay free of this copy because LogoHeaderTemplate
 * is also used by the "Dettagli app" tab, where the same box takes the mobile
 * app's internal icon (SVG, no size limit) and none of this text is true.
 */
const LogoHalf = ({ titolo, descrizione, consiglioRapporto, children }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.intestazione}>
        <Typography
          variant="subtitle1"
          component="h3"
          className={classes.titolo}
        >
          {titolo}
        </Typography>
        <Typography className={classes.descrizione}>{descrizione}</Typography>
      </div>
      <div className={classes.riquadro}>{children}</div>
      <SpecificheLogo consiglioRapporto={consiglioRapporto} />
    </div>
  );
};

LogoHalf.propTypes = {
  titolo: PropTypes.string.isRequired,
  descrizione: PropTypes.string.isRequired,
  consiglioRapporto: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default LogoHalf;
